export const Headers = () => {
    return { "Authorization": sessionStorage.getItem('token') }
}